export const FEATURE_SESSION_KEY = 'FEATURE_SESSION_KEY';
